import { Pipe, PipeTransform } from '@angular/core';
import { isNumberFinite, isPositive, isInteger, toDecimal } from './utils/utils';

export type ByteUnit = 'B' | 'KB' | 'MB' | 'GB';

@Pipe({
  name: 'bytes'
})
export class BytesPipe implements PipeTransform {


  static formats: { [key: string]: { fa: string, en: string, max: number, prev?: ByteUnit } } = {
    'B': { fa: 'بایت', en: 'B', max: 1024 },
    'KB': { fa: 'کیلوبایت', en: 'KB', max: Math.pow(1024, 2), prev: 'B' },
    'MB': { fa: 'مگابایت', en: 'MB', max: Math.pow(1024, 3), prev: 'KB' },
    'GB': { fa: 'گیگابایت', en: 'GB', max: Number.MAX_SAFE_INTEGER, prev: 'MB' }
  };


  transform(input: any, decimal: number = 2, from: ByteUnit = 'B', lang: string = 'en'): any {

    let sign = '';

    if (Math.sign(input) === -1) {
      sign = '-';
      input = Math.abs(input);
    }

    if (!(isNumberFinite(input) &&
      isNumberFinite(decimal) &&
      isInteger(decimal) &&
      isPositive(decimal))) {
      return input;
    }

    let bytes = input;
    let unit = from;
    while (unit !== 'B') {
      bytes *= 1024;
      unit = BytesPipe.formats[unit].prev;
    }

    for (const key of Object.keys(BytesPipe.formats)) {
      const format = BytesPipe.formats[key];
      if (bytes < format.max) {

        const prev = format.prev ? BytesPipe.formats[format.prev] : undefined;

        const result = prev ?
          toDecimal(bytes / prev.max, decimal) :
          toDecimal(bytes, decimal);

        return `${result}${sign} ${format[lang]}`;
      }
    }
  }
}
